/*
 
 */
var InputChoice = /** @class */ (function () {
    function InputChoice(selector) {
        this.initClassName = "-isInit";
        this.className = "-active";
        if (!$(selector).hasClass(this.initClassName)) {
            this.init(selector);
        }
    }
    InputChoice.prototype.init = function (selector) {
        this.selector = $(selector).attr("for");
        this.DOM = {
            $input: $('[name="' + this.selector + '"'),
        };
        this.DOM.$input.addClass(this.initClassName);
        this.addEvents();
        this.changeInput(this.DOM.$input);
    };
    InputChoice.prototype.changeInput = function ($input) {
        var value = null;
        switch ($input.get(0).type) {
            case "select-one":
                value = $input.find(':selected').attr('data-change');
                break;
            case "radio":
                value = $input.filter(':checked').attr('data-change');
                break;
            default:
                value = $input.data("change");
        }
        if (this.DOM.$target) {
            this.DOM.$target.removeClass(this.className);
            this.DOM.$target = null;
        }
        if (value) {
            var $target = $('[data-wrapper="' + value + '"');
            if ($target.get(0)) {
                $target.addClass(this.className);
                this.DOM.$target = $target;
            }
        }
    };
    InputChoice.prototype.addEvents = function () {
        var _this = this;
        this.DOM.$input.change(function (e) {
            var $input = $(e.currentTarget);
            _this.changeInput($input);
        });
    };
    return InputChoice;
}());
;
